
import { Options, Vue } from "vue-class-component";
import { MenuStore, ModalStore } from "@/store/index";
import { translate } from "@/helpers/locale-helper";

@Options({
  components: {
  },
  props: {
    id: Number,
    show: Boolean,
    backdropExit: Boolean,
    escKey: Boolean,
    allowExit: Boolean,
    submitAnimation: Boolean,
    showExit: Boolean
  },
  emits: ["opened", "closed", "toggled"]
})
export default class BaseModal extends Vue {
  // declare element references
  declare $refs: {
    modal: HTMLElement;
  };

  id!: number;
  modalUnwatch!: Function;
  show!: boolean;
  backdropExit: boolean = true;
  escapeKey: boolean = true;
  display: boolean = false;
  allowExit: boolean = true;
  showExit: boolean = true;
  submitAnimation: boolean = false;
  timers: number[] = [];

  get backdropEvent() {
    return this.backdropExit ? "click" : null;
  }

  get escKeyEvent() {
    return this.backdropExit ? "keydown" : null;
  }

  get btnCloseTitle() {
    return translate(this.$i18n.locale, 'general.modal_close');
  }

  addClass() {
    this.doActionWhenRefReady(() => {
        const modal = this.$refs.modal;
        modal.classList.add(`paper-model-${Math.floor(Math.random() * 3)}`);
    });
  }

  open() {
    this.display = true;

    this.$emit("opened");
    this.$emit("toggled", this.display);
    MenuStore.close();

    this.addClass();
  }

  close() : void {
    if (!this.allowExit) return;

    ModalStore.onClose();

    this.display = false;

    for (let timer of this.timers) 
      clearTimeout(timer);

    this.$emit("closed");
    this.$emit("toggled", this.display);
  }

  mounted() {
    this.$watch('show', (value: boolean, oldValue: boolean) => {
      // make sure the value changed
      if (value == oldValue) return;

      if (!value) {
        if (typeof oldValue !== 'undefined') {
          this.close();
        }
        return;
      }

      this.open();
    });
    
    document.addEventListener("keydown", (e) => {
      if (!this.backdropExit) return;
      if (e.keyCode == 27) {
        this.close();
      }
    });

    this.modalUnwatch = ModalStore.$watch(
      (store) => store.closes,
      (value, legacyValue) => {
        /**
         * Cheese solution, the binding of certain data haven't been update before the close event
         */
        this.doActionWhenRefReady(this.close.bind(this));
      }
    );
  }

  unmounted() {
    if (this.modalUnwatch) this.modalUnwatch();

    for (let timer of this.timers) 
      clearTimeout(timer);
  }

  doActionWhenRefReady(callback: Function) {
    if (this.$refs.modal) {
      callback.bind(this)();
      return;
    }

    this.timers.push(setTimeout(this.doActionWhenRefReady.bind(this), 50, callback));
  }
}
